var _BookmarkServiceInit_instances, _BookmarkServiceInit_bookmarks, _BookmarkServiceInit_storage, _BookmarkServiceInit_loadBookmarks, _BookmarkServiceInit_saveBookmarks;
import { __classPrivateFieldGet } from "tslib";
import { get, writable } from 'svelte/store';
import { LocalStorageManager } from '../model/storage/LocalStorageManager';
class BookmarkServiceInit {
    constructor() {
        _BookmarkServiceInit_instances.add(this);
        _BookmarkServiceInit_bookmarks.set(this, writable([]));
        _BookmarkServiceInit_storage.set(this, new LocalStorageManager());
        __classPrivateFieldGet(this, _BookmarkServiceInit_instances, "m", _BookmarkServiceInit_loadBookmarks).call(this);
    }
    get bookmarks() {
        return __classPrivateFieldGet(this, _BookmarkServiceInit_bookmarks, "f");
    }
    addBookmark(bookmark) {
        const bookmarks = get(__classPrivateFieldGet(this, _BookmarkServiceInit_bookmarks, "f"));
        if (bookmarks.every((b) => b !== bookmark)) {
            __classPrivateFieldGet(this, _BookmarkServiceInit_bookmarks, "f").update((it) => [...it, bookmark]);
        }
        __classPrivateFieldGet(this, _BookmarkServiceInit_instances, "m", _BookmarkServiceInit_saveBookmarks).call(this);
    }
    removeBookmark(bookmark) {
        __classPrivateFieldGet(this, _BookmarkServiceInit_bookmarks, "f").update((it) => it.filter((it) => it !== bookmark));
        __classPrivateFieldGet(this, _BookmarkServiceInit_instances, "m", _BookmarkServiceInit_saveBookmarks).call(this);
    }
}
_BookmarkServiceInit_bookmarks = new WeakMap(), _BookmarkServiceInit_storage = new WeakMap(), _BookmarkServiceInit_instances = new WeakSet(), _BookmarkServiceInit_loadBookmarks = function _BookmarkServiceInit_loadBookmarks() {
    const rawBookmarks = __classPrivateFieldGet(this, _BookmarkServiceInit_storage, "f").bookmarks;
    const bookmarks = JSON.parse(rawBookmarks);
    __classPrivateFieldGet(this, _BookmarkServiceInit_bookmarks, "f").set(bookmarks);
}, _BookmarkServiceInit_saveBookmarks = function _BookmarkServiceInit_saveBookmarks() {
    const bookmarks = get(__classPrivateFieldGet(this, _BookmarkServiceInit_bookmarks, "f"));
    const rawBookmarks = JSON.stringify(bookmarks);
    __classPrivateFieldGet(this, _BookmarkServiceInit_storage, "f").bookmarks = rawBookmarks;
};
export const BookmarkService = new BookmarkServiceInit();
